import { render } from "./DiscountItem.vue?vue&type=template&id=7e25de30&scoped=true"
import script from "./DiscountItem.vue?vue&type=script&lang=js"
export * from "./DiscountItem.vue?vue&type=script&lang=js"

import "./DiscountItem.vue?vue&type=style&index=0&id=7e25de30&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e25de30"]])

export default __exports__